<template>
    <div>
        <custom-tooltip v-model="isOpen" border>
            <app-button circle icon @click="redirectTo">
                {{ icon }}
            </app-button>
            <template #tooltip> {{ message }} </template>
        </custom-tooltip>
    </div>
</template>

<script>
export default {
    name: "TooltipRedirect",
    props: {
        to: { default: "/app", type: String, required: true },
        message: { default: "Nuevo", type: String, required: true },
        icon: { default: "➕", type: String, required: false },
        openNewTab: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    data: () => ({ isOpen: false, enabledRedirect: false }),
    methods: {
        redirectTo() {
            if (this.isOpen) {
                this.isOpen = false;
                setTimeout(() => {
                    if (this.openNewTab) {
                        window.open(this.to, "_blank").focus();
                        return;
                    }
                    this.$router.push(this.to);
                }, 100);
            } else {
                this.isOpen = true;
                setTimeout(() => (this.isOpen = false), 5000);
            }
        }
    }
};
</script>
